var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgClose = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9102 38.1079C30.4036 38.1079 38.9102 29.6013 38.9102 19.1079C38.9102 8.6145 30.4036 0.10791 19.9102 0.10791C9.41681 0.10791 0.910217 8.6145 0.910217 19.1079C0.910217 29.6013 9.41681 38.1079 19.9102 38.1079Z",
    fill: "#ACCE42"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.295 14.115C26.6844 13.7256 26.6844 13.0944 26.295 12.705V12.705C25.9056 12.3156 25.2744 12.3156 24.885 12.705L20.7071 16.8829C20.3166 17.2734 19.6834 17.2734 19.2929 16.8829L15.115 12.705C14.7256 12.3156 14.0944 12.3156 13.705 12.705V12.705C13.3156 13.0944 13.3156 13.7256 13.705 14.115L17.8829 18.2929C18.2734 18.6834 18.2734 19.3166 17.8829 19.7071L13.705 23.885C13.3156 24.2744 13.3156 24.9056 13.705 25.295V25.295C14.0944 25.6844 14.7256 25.6844 15.115 25.295L19.2929 21.1171C19.6834 20.7266 20.3166 20.7266 20.7071 21.1171L24.885 25.295C25.2744 25.6844 25.9056 25.6844 26.295 25.295V25.295C26.6844 24.9056 26.6844 24.2744 26.295 23.885L22.1171 19.7071C21.7266 19.3166 21.7266 18.6834 22.1171 18.2929L26.295 14.115Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgClose, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Close.3d50f8c8.svg";
export { ForwardRef as ReactComponent };